import { combineReducers } from 'redux';

import pending from './pending';

export default combineReducers({
    pending,
});
